import { useEffect } from 'react';
import AOS from 'aos';
import Header from './common/Header';
import Hero from './sections/Hero';
import About from './sections/About';
import Services from './sections/Services';
import Training from './sections/Training';
import Gallery from './sections/Gallery';
import Contact from './sections/Contact';
import Footer from './common/Footer';

const App = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <>
            <Header />
            <Hero />
            <About />
            <Services />
            <Training />
            <Gallery />
            <Contact />
            <Footer />
        </>
    );
};

export default App;

